"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Animate_1 = require("./Animate");
exports.default = Animate_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Animate/index.js
// module id = 457
// module chunks = 8